import { createContext, JSX } from "react"

export type UserContextType = {
    username: string
}

interface propsInterface {
    userdata: UserContextType
    children: JSX.Element
}

export const Context = createContext<UserContextType>({ username: "" })

export default function UserContext(props: propsInterface) {
    const { children, userdata } = props

    return (
        <Context.Provider value={ userdata }>
            { children }
        </Context.Provider>
    )
}